const generateStrongPassword = (length=8) => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    const lower = "abcdefghijklmnopqrstuvwxyz"
    const digits = "0123456789"
    const special = "!@#$%^&*()_+~"
    const all = upper + lower + digits + special

    const getRandom = (chars) =>
      chars.charAt(Math.floor(Math.random() * chars.length))

    let password = [
      getRandom(upper),
      getRandom(lower),
      getRandom(digits),
      getRandom(special),
    ]

    for (let i = 1; i <= length-4; i++) {
      password.push(getRandom(all))
    }

    return password = password.sort(() => Math.random() - 0.5).join("")
}

export default generateStrongPassword